import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastNotification = {
  success: (
    message,
    options = { position: 'top-right', autoClose: 2500 }  // using string 'top-right'
  ) => {
    toast.success(message, options);
  },
  error: (
    message,
    options = { position: 'top-right', autoClose: 2500 }
  ) => {
    toast.error(message, options);
  },
  warning: (
    message,
    options = { position: 'top-right', autoClose: 2500 }
  ) => {
    toast.warn(message, options);
  },
  info: (
    message,
    options = { position: 'top-right', autoClose: 2500 }
  ) => {
    toast.info(message, options);
  },
};

export default ToastNotification;
